import { PricingCards } from "@/components/PricingCards";
import { PromoRedeem } from "@/components/PromoRedeem";

export default function Pricing() {
  return (
    <main className="max-w-6xl mx-auto px-4 sm:px-6 py-16">
      <h1 className="rise text-4xl sm:text-5xl font-extrabold tracking-tight">Plans for travelers <span className="text-[#FFB800]">& businesses</span></h1>
      <p className="text-base md:text-lg text-slate-400 mt-3 mb-10 max-w-2xl">Travelers get 7 days free (2 devices), families get 10 days free (5 devices on one login). Businesses get 7 days free, then a flat $25/month to be featured in their city. Any plan can add 20 profile photos for +$3/month (Family includes them).</p>
      <PricingCards />
      <div className="mt-6 max-w-xl"><PromoRedeem /></div>
      <p className="text-xs text-slate-500 mt-6">Payments are processed securely by Stripe. Subscriptions renew monthly.</p>
    </main>
  );
}
